export default __webpack_public_path__ + "static/media/icon-extrato.581748ab.svg";